<template>
  <layout logoColor="black" toolbarColor="white">
    <div class="hero-wrapper">
      <v-container class="page-wrapper">
        <div>
          <p>Investment Advisor Lending Solutions</p>
          <h1>We help you find the right lender the first time</h1>
        </div>
      </v-container>
      <div class="img-wrapper">
        <img src="~@/modules/home/assets/about-hero.png" />
      </div>
    </div>

    <v-container>
      <section>
        <h2>About LendingWell</h2>
        <p>
          If you are looking to grow your Registered Investment Advisor (RIA), agency, tax practice, or securities practice through acquisition or find financing for your successors, finding and evaluating all the financing options is incredibly time-consuming and challenging. LendingWell takes the guesswork out of finding the best lender for your deal.
        </p>

        <p>
          Our advanced algorithm will take into consideration your needs, the deal structure and requirements, and timeline, and match you with lenders that fit your deal, pulling from the most comprehensive database of industry lenders available - saving you time and money. LendingWell is the ultimate matchmaking solution for advisors looking for capital to buy, sell, or merge a business.
        </p>

        <router-link
          class="default-btn blue"
          :to="{ name: 'QuestionnaireEntry' }"
        >Find a Lender</router-link>
      </section>

      <section>
        <h2>Why LendingWell</h2>

        <div class="grid-wrapper why-grid">
          <div>
            <h3>The Only Complete Advisor lending Toolkit</h3>
            <p>
              No other platform provides such a simple, completely automated, and free set of resources to help with your financing needs as an advisor, agent, and/or account. From our matching algorithm, to our directory of resource providers, we’ve got you covered - and the resources continue to expand!
            </p>
          </div>
          <img src="~@/modules/home/assets/briefcase.svg" />

          <img src="~@/modules/home/assets/money-falling.svg" />
          <div>
            <h3>We've Been There - Done That</h3>
            <p>
              Created by Succession Resource Group, LendingWell was built by leading M&A experts. We’re dedicated to helping you understand the nuances of the industry and guide you to the best lending solutions for your financing needs.
            </p>
          </div>

          <div>
            <h3>More Money In Your Pocket</h3>
            <p>
              Whether you are just starting your search, or think you already have a good financing solution, LendingWell can help make sure you make the right choice the first time. And, through our partnerships, advisors who find financing through LendingWell can save up to $2,000 on closing costs.
            </p>
          </div>
          <img src="~@/modules/home/assets/fast-cash.svg" />
        </div>
      </section>

      <section>
        <h2>Our Team</h2>
        <div class="grid-wrapper team-grid">
          <div v-for="person in team" class="team-card">
            <img v-if="$vuetify.breakpoint.mdAndUp" :src="person.imgLarge" />
            <img v-else :src="person.img" />
            <div>
              <h4>{{ person.name }}</h4>
              <h5>{{ person.title }}</h5>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2>Featured LendingWell Partners</h2>

        <carousel
          autoplay :autoplayTimeout="2000" :loop="true"
          :scrollPerPage="false"
          :centerMode="true"
          :pagination-enabled="false"
          :mouse-drag="false"
          :touch-drag="false"
        >
          <slide
            v-for="(partner, i) in partners"
            :key="i"
          >
            <img :src="partner.img" />
          </slide>
        </carousel>

        <div class="btn-group">
          <router-link
            class="default-btn blue"
            :to="{ name: 'QuestionnaireEntry' }"
          >Find a Lender</router-link>
        </div>
      </section>
    </v-container>
  </layout>
</template>

<script>
import * as banks from '@/modules/home/assets/banks'
import * as team from '@/modules/home/assets/team'
import Layout from '@/modules/home/components/ui/layout'

export default {
  name: 'AboutPage',
  components: {
    Layout,
  },
  data: () => ({
    partners: [
      { img: banks.ppcLoan },
      { img: banks.pinnacle },
      { img: banks.liveOak },
      // { img: banks.saltCreek },
      { img: banks.oakStreet },
    ],
    team: [
      {
        name: 'David Grau Jr. MBA',
        title: 'Co-founder',
        img: team.davidGrau,
        imgLarge: team.davidGrau2x,
      },
      {
        name: 'Kristen Grau CPA, CVA',
        title: 'Co-founder',
        img: team.kristenGrau,
        imgLarge: team.kristenGrau2x,
      },
      {
        name: 'Nicole Sinclair',
        title: 'Business Development Manager',
        img: team.nicoleSinclair,
        imgLarge: team.nicoleSinclair2x,
      },
      {
        name: 'Kuo-Hsuan ‘David’ Pan',
        title: 'Marketing & Brand Manager',
        img: team.kuoHsuanPan,
        imgLarge: team.kuoHsuanPan2x,
      },
      // {
      //   name: 'Anden Leesley',
      //   title: 'User Experience Designer',
      //   img: team.andenLeesley,
      //   imgLarge: team.andenLeesley2x,
      // },
      {
        name: 'Cliff Weiler',
        title: 'Applications Engineer',
        img: team.cliffWeiler,
        imgLarge: team.cliffWeiler2x,
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.container {
  p {
    color: #505050;
  }

  h1, h2, h3, h4 {
    color: $accentBlue;
    font-family: "Sansation Bold", sans-serif;
  }

  h1 {
    color: white;
    text-transform: uppercase;
  }

  h2 {
    position: relative;
    margin-bottom: 50px;
    padding-left: 12px;

    font-size: 22px;
    line-height: 26px;
    text-transform: uppercase;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 4px;
      background-color: $primaryGreen;
      border-radius: 16px;
    }
  }

  h3 {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 21px;
    text-transform: capitalize;
  }

  h4 {
    margin-bottom: 8px;
    color: white;
    font-size: 16px;
    line-height: 18px;
  }

  h5 {
    color: white;
    font-family: "Avenir Book", sans-serif;
    font-size: 15px;
    font-weight: normal;
    line-height: 20px;
  }

  section {
    padding: 70px 0;
  }

  .default-btn {
    margin-top: 30px;
  }

  .grid-wrapper {
    @include lg {
      padding: 0 50px;
    }
  }

  .grid-wrapper.why-grid {
    grid-row-gap: 20px;
    grid-template-columns: 1fr;
    align-items: center;

    div {
      text-align: center;
      &:nth-of-type(1) { order: 2; }
      &:nth-of-type(2) { order: 4; }
      &:nth-of-type(3) { order: 6; }
    }

    img {
      height: 120px;
      width: 145px;
      margin: auto;

      &:nth-of-type(1) { order: 1; }
      &:nth-of-type(2) { order: 3; }
      &:nth-of-type(3) { order: 5; }
    }

    @include lg {
      grid-gap: 40px 20px;
      grid-template-columns: 1fr 1fr;

      div {
        text-align: left;
        &:nth-of-type(1) { order: 1; }
        &:nth-of-type(2) { order: 4; }
        &:nth-of-type(3) { order: 5; }
      }

      img {
        height: 250px;
        width: 320px;

        &:nth-of-type(1) { order: 2; }
        &:nth-of-type(2) { order: 3; }
        &:nth-of-type(3) { order: 6; }
      }
    }
  }

  .grid-wrapper.team-grid {
    padding: 0;
    grid-row-gap: 40px;
    grid-template-columns: auto;
    justify-content: space-around;

    @include md {
      grid-row-gap: 60px;
      grid-template-columns: repeat(2, auto);
    }

    @include lg {
      grid-row-gap: 75px;
      grid-template-columns: repeat(3, auto);
    }
  }

  .team-card {
    @include md {
      background-color: $accentBlue;
      border: 1px solid $accentBlue;
      border-radius: 4px;
    }

    img {
      height: 190px;
      width: 205px;

      border-radius: 4px;

      @include md {
        height: 264px;
        width: 220px;
        border-radius: 0;
      }

      @include lg {
        height: 300px;
        width: 250px;
      }
    }

    div {
      height: auto;
      width: 210px;

      h4, h5 { color: $accentBlue; }

      @include md {
        height: 80px;
        padding: 8px;

        h4, h5 { color: white; }
      }

      @include lg {
        width: 250px;
        padding: 12px;
      }
    }
  }
}

.hero-wrapper {
  position: relative;
  margin-top: 100px;
  background-color: $accentBlue;

  .img-wrapper {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    background-color: $primaryGreen;
    clip-path: polygon(200px 0%, 100% 0%, 100% 100%, 320px 100%);

    @include lg { display: block; }

    img {
      height: 100%;
      width: auto;
      max-width: 65vw;
      margin-left: auto;
      clip-path: polygon(210px 0%, 100% 0%, 100% 100%, 330px 100%);
    }
  }

  .container {
    padding-top: 30px;
    padding-bottom: 30px;

    div {
      max-width: 80%;

      @include lg {
        max-width: 460px;
      }
    }

    position: relative;
    z-index: 2;
  }

  p {
    margin-bottom: 0;
    color: white;
    font-size: 20px;
    line-height: 26px;
  }
}

.VueCarousel {
  margin-bottom: 40px;

  .VueCarousel-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
